import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

import AuthReducer from './AuthReducer'
import CustomFormReducer from './CustomFormReducer'
import OrganizationReducer from './OrganizationReducer'
import StudentReducer from './StudentReducer'

export default combineReducers({
    auth: AuthReducer,
    customForm: CustomFormReducer,
    form: formReducer,
    organization: OrganizationReducer,
    student: StudentReducer
});


export const persistentStoreBlacklist = [
    'auth',
    'customForm',
    'organization',
    'student'
];


// WEBPACK FOOTER //
// ./src/Reducers/index.js